import {
  SUBMIT_NPS,
  SUBMIT_NPS_SUCCESS,
  SUBMIT_NPS_FAILURE,
  NPS_HANDLE,
  NPS_HANDLE_SUCCESS,
  NPS_HANDLE_FAILURE,
} from "./types";

export const submitNps = (payload) => ({
  type: SUBMIT_NPS,
  payload,
});

export const submitNpsSuccess = () => ({
  type: SUBMIT_NPS_SUCCESS,
});

export const submitNpsFailure = () => ({
  type: SUBMIT_NPS_FAILURE,
});

/** @param {{ action: 'LOGIN' | 'SKIP', onSuccess?: () => void, onFailure?: () => void }} payload */
export const npsHandle = (payload) => ({
  type: NPS_HANDLE,
  payload,
});

export const npsHandleSuccess = (result) => ({
  type: NPS_HANDLE_SUCCESS,
  payload: result,
});

export const npsHandleFailure = () => ({
  type: NPS_HANDLE_FAILURE,
});
